<template>
  <div class="modal-location">
    <label class="modal-location__header">
      {{$t('monitoring.map.new-installation-localization')}} <br />
    </label>
    <div
      class="modal-location__info"
    >
      <label>
        {{ $t('monitoring.map.installation') }}:
      </label>
      {{installationName}}
    </div>
    <div class="modal-location__body">
      <s-multiselect
        :proxy-binds="{
              options: options,
              label: 'label',
              trackBy: 'label',
              preserveSearch: false,
              internalSearch: false,
              multiple: false,
              loading,
            }"
        v-model="searchProxy"
        @input="setPlace"
        v-s-trigger:search-change="searchTerm"
      ></s-multiselect>
      <div v-if="markerToEdit" class="modal-location__lat-lng">
        <div>
          <label>
            Lat:
          </label>
          {{ markerLat }}
        </div>
        <div>
          <label>
            Lng:
          </label>
          {{ markerLng }}
        </div>
      </div>
    </div>
    <div class="modal-location__footer">
      <b-button
        @click="cancelLocation">
        {{ $t('general.cancel') }}
      </b-button>
      <b-button
        variant="primary"
        @click="saveLocation">
        {{ $t('general.save') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import {
  OpenStreetMapProvider,
} from 'leaflet-geosearch';
import clone from 'lodash/clone';

export default {
  props: {
    installationName: String,
    markerToEdit: Object,
    draggedTo: Object,
    search: {
      type: [Object, String],
    },
  },
  watch: {
    markerToEdit(marker) {
      if (marker.position !== undefined) {
        this.getAddressByCoordinates(marker.position.lat, marker.position.lng);
      }
    },
    draggedTo(position) {
      this.getAddressByCoordinates(position.lat, position.lng);
    },
  },
  data() {
    return {
      provider: {},
      options: [],
      loading: false,
    };
  },
  computed: {
    markerLat() {
      const lat = clone((this.markerToEdit.position || {}).lat);
      return lat ? lat.toString().slice(0, 10) : '--';
    },
    markerLng() {
      const lng = clone((this.markerToEdit.position || {}).lng);
      return lng ? lng.toString().slice(0, 10) : '--';
    },
    searchProxy: {
      get() {
        return this.search;
      },
      set(value) {
        this.$emit('update:search', value);
      },
    },
  },
  methods: {
    searchTerm(term) {
      this.loading = true;
      this.provider.search({ query: term })
        .then((result) => { this.options = result; })
        .catch(() => { this.$pushAlert({ code: 'MA011' }); })
        .finally(() => { this.loading = false; });
    },
    getAddressByCoordinates(lat, lon) {
      this.loading = true;
      const reversedType = 1;
      const searchQuery = {
        query: {
          lat,
          lon,
          format: 'json',
        },
        type: reversedType,
      };

      this.provider.search(searchQuery)
        .then((result) => { this.$emit('update:search', result[0]); })
        .catch(() => {
          this.$pushAlert({ code: 'MA011' });
          this.$emit('update:search', '');
        })
        .finally(() => { this.loading = false; });
    },
    setPlace(place) {
      const latLngData = {
        lat: place.y,
        lng: place.x,
      };
      const newMarker = { ...this.markerToEdit, position: latLngData };
      this.$emit('update:marker-to-edit', newMarker);
      this.$emit('setPlace', { latLng: newMarker.position });
      this.searchProxy = place;
    },
    saveLocation() {
      if (this.searchProxy === '' || this.loading) {
        this.$pushAlert({
          code: 'MA011',
        });
        return;
      }

      this.searchProxy = '';
      this.$emit('saveLocation', { latLng: this.markerToEdit.position });
    },
    cancelLocation() {
      this.searchProxy = '';
      this.options = [];
      this.$emit('cancelLocation');
    },
    setProvider() {
      this.provider = new OpenStreetMapProvider();
      // O provider utilizado possuia implementado o comportamento de reverse porém não possuia uma
      // função para chamá-lo, e tentando setar o type pela função search não era possível devido
      // ao parametro type estar sendo setado pela própria função, então copiamos a implementação
      // do github da dependencia e apenas alteramos para que o parametro type possa aceitar o
      // tipo de consulta que está sendo realizado, se é search ou reverse
      this.provider.search = async (options) => {
        const url = this.provider.endpoint({
          query: options.query,
          type: options.type || 0,
        });

        const request = await fetch(url);
        const json = await request.json();
        return this.provider.parse({ data: json });
      };
    },
  },
  created() {
    this.setProvider();
  },
};
</script>
<style lang="sass" scoped>
  @import "src/styles/defaults/variables"
  @import "src/styles/defaults/mobile-first"

  .modal-location
    background: var(--color-modal-background)
    border: 1px solid #000
    max-width: 600px
    padding: 10px
    position: absolute
    margin-left: auto
    margin-right: auto
    left: 0
    right: 0
    z-index: 2
    &__header
      font-size: 1.05em
    &__info
      font-size: 0.95em
    &__lat-lng
      font-size: .9rem
      display: flex
      justify-content: flex-end
      +media-xs
        flex-direction: column
        align-items: flex-end
      label
        margin: 0 5px
    &__body
      display: flex
      flex-direction: column
      ::v-deep .multiselect__spinner
        height: 30px
    &__btn-search
      margin-left: 5px
    &__footer
      margin-top: 10px
      display: flex
      justify-content: flex-end
      > *:not(:first-child)
        margin-left: 10px
</style>
